import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
class EdRadio extends Vue {

  @Prop({}) readonly value: any;
  @Prop({}) readonly disabled: boolean;
  @Prop({}) readonly name: boolean;
  @Prop({}) readonly initialCheck: boolean;

  get disabledInput(){
    if(this.disabled)
      return { 'cursor': 'initial' }
  }

  onChange() {
    this.$emit('input', this.value);
  }
}

export default Vue.component('ed-radio', EdRadio);